import { capitalize } from 'helpers/utils';
import AwardsIcons from './AwardsIcons';
import { SEARCH_ZONES_KEYS } from 'components/constants/Constants';
import { AwardDisplayProps } from './types';

export const AwardDisplay: React.FC<AwardDisplayProps> = props => {
  const { award, size } = props;

  const toolTip = `${award.event.name}${' | ' + award.year} ${
    ' | ' + award.category.name
  }  ${
    (Object.values(SEARCH_ZONES_KEYS) as string[]).includes(award?.category.key)
      ? ''
      : award?.winner
      ? ` | ${award?.prize_level} Award`
      : award?.shortlisted
      ? ' | Award Nominee'
      : ''
  }`;
  const iconValue = getCorrectAwardIconName(award);
  return <AwardsIcons awardValue={iconValue} toolTip={toolTip} size={size} />;
};

const getCorrectAwardIconName = (award: any) => {
  let iconName = '';
  const key = award?.category.key;

  if (key === 'innovation-zone') {
    return 'innovation-zone.svg';
  }
  if (key === 'sustainability-zone') {
    return 'sustainability-zone.svg';
  }
  if (key) {
    switch (key) {
      case 'rising-star':
        iconName = 'risingStar';
        break;
      case 'green-ingredient':
        iconName = 'Green';
        break;
      case 'kenvue-trusted-science-award':
        iconName = 'Kenvue';
        break;
      default:
        iconName = 'FI';
        break;
    }
  }

  iconName +=
    '-' +
    capitalize(
      award?.winner
        ? award?.prize_level === 'WINNER'
          ? 'Gold'
          : award?.prize_level === 'RUNNER_UP'
          ? 'Silver'
          : award.prize_level !== 'NONE'
          ? award.prize_level
          : 'Nominee'
        : 'Nominee'
    );

  return iconName + '.svg';
};
